import styled from 'styled-components';
import { isNumber } from '@agilepoint/utils-common';
import { ICalloutPositionStyles } from '../callout-types';

export const CalloutContentWrapper = styled.div.attrs({
    className: String('ap-callout-content')
}) <{ $contentPositionStyles: ICalloutPositionStyles['contentPositionStyles'] }>`
    background-color: ${({ theme: { callout: { colors } } }) => colors.backgroundColor};
    max-height: ${({ $contentPositionStyles: { maxHeight } }) => (isNumber(maxHeight) ? `${maxHeight}px` : '100%')};
    max-width: ${({ $contentPositionStyles: { maxWidth } }) => (isNumber(maxWidth) ? `${maxWidth}px` : '100%')};
    position: relative;
    border-radius: inherit;
    height: 100%;
    width: 100%;
    box-sizing: border-box;
    overflow: auto;
    z-index: 5;
`;
